/*
 * Public API Surface of managers
 */

export * from './pages/managers.component';
export * from './lib/managers.module';
